import { useGetDashboardQuery } from '../../../api/ua-insights'
import { useUAInsightsScope } from './useUAInsightsNavigation'

export const useUAInsightsDashboard = () => {
  const { networkId, month, genreFilter } = useUAInsightsScope()
  const { data, isFetching, isError, refetch } = useGetDashboardQuery({
    networkId: networkId ?? undefined,
    month: month ?? undefined,
    genreId: genreFilter ?? undefined,
  })
  return { data, isLoading: isFetching, isError, refetch }
}
